import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 39 39" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M25.31 5.744c5.439 5.437 5.439 14.253 0 19.69-5.437 5.44-14.253 5.44-19.69 0-5.44-5.437-5.44-14.253 0-19.69 5.437-5.438 14.253-5.438 19.69 0zM27.717 28.687l9.552 8.707" /></svg>;